import { render, staticRenderFns } from "./ptBestOfTheBest.vue?vue&type=template&id=df3f2df8&"
import script from "./ptBestOfTheBest.vue?vue&type=script&lang=js&"
export * from "./ptBestOfTheBest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports